import React, { Component } from "react";
import Navigation from "../Navigation";
import Notificaciones from "../overview/Notificaciones";
import GCaudal1 from "../overview/GCaudal1";
import GVolumen1 from "../overview/GVolumen1";
import GCaudal2 from "../overview/GCaudal2";
import GVolumen2 from "../overview/GVolumen2";
import GBatery from "../../dashboard/overview/GBatery";
import GSignal from "../../dashboard/overview/GSignal";
import GTempE from "../../dashboard/overview/GTempE";
import axios from "axios";
import { withRouter } from "react-router-dom";
import https from "https";
const instance = axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false
  })
});
export class Graficas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lecturas: [],
      fecha1: "",
      fecha2: "",
      sitio: "",
      contador: 1
    };
  }

  fecha1(event) {
    this.setState({ fecha1: event.target.value });
  }
  fecha2(event) {
    this.setState({ fecha2: event.target.value });
  }
  async cargarlecturas() {
    const res = await instance.get(
      "https://api.instrutronica-iot.com/api/pruebas/lecturas2/fechas/" +
        this.state.sitio +
        "/" +
        this.state.fecha1 +
        "/" +
        this.state.fecha2
    );
    this.setState({ lecturas: res.data });
  }

  async componentDidMount() {
    var query = window.location.href;
    var sit = query.split("/");
    const res = await instance.get(
      "https://api.instrutronica-iot.com/api/pruebas/lecturas2/hoy/" + sit[5]
    );
    this.setState({ lecturas: res.data });
    this.setState({ sitio: sit[5] });
    this.interval = setInterval(async () => {
      if (localStorage.getItem("pruebas_app") == null) {
        this.props.history.push("/");
      }
    }, 1000);
  }

  render() {
    var styles1 = {};
    var styles2 = {};
    if (this.state.lecturas.length > 0) {
      styles1 =
        this.state.lecturas[0].caudal_1 === null &&
        this.state.lecturas[0].volumen_1 === null
          ? { display: "none" }
          : {};
      styles2 =
        this.state.lecturas[0].caudal_2 === null &&
        this.state.lecturas[0].volumen_2 === null
          ? { display: "none" }
          : {};
    }
    return (
      <div>
        <Navigation></Navigation>
        <div className="page">
          <header className="header">
            <nav className="navbar">
              <div className="container-fluid">
                <div className="navbar-holder d-flex align-items-center justify-content-between">
                  <div className="navbar-header">
                    <button id="toggle-btn" className="menu-btn btn-dark">
                      <i className="icon-bars"> </i>
                    </button>
                    <span href="index.html" className="navbar-brand">
                      <div className="brand-text d-none d-md-inline-block">
                        <span style={{ color: "#ccc" }}>{} </span>
                        <strong className="text-primary"> {}</strong>
                      </div>
                    </span>
                  </div>
                  <Notificaciones></Notificaciones>
                </div>
              </div>
            </nav>
          </header>
          <div className="breadcrumb-holder">
            <div className="container-fluid">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">Vista General</li>
                <li className="breadcrumb-item active">Gráficas </li>
              </ul>
            </div>
          </div>

          <section className="charts">
            <div className="container-fluid">
              <header>
                <h1 className="h3 display">Gráficas </h1>
                <p>
                  Para ver datos en las gráficas elija primero las fechas y
                  luego presione Cargar Lecturas
                </p>
              </header>
              <div className="row">
                <div className="col-lg-12">
                  <div className="input-group">
                    <input
                      id="fecha1"
                      onChange={this.fecha1.bind(this)}
                      type="date"
                      className="form-control"
                      placeholder="Fecha Inicial"
                      aria-label="Fecha Inicial"
                      aria-describedby="button-addon4"
                    ></input>
                    <input
                      id="fecha2"
                      onChange={this.fecha2.bind(this)}
                      type="date"
                      className="form-control"
                      placeholder="Fecha Final"
                      aria-label="Fecha fianl"
                      aria-describedby="button-addon4"
                    ></input>
                    <div className="input-group-append" id="button-addon4">
                      <button
                        className="btn  btn-success"
                        type="button"
                        onClick={this.cargarlecturas.bind(this)}
                      >
                        Cargar Lecturas
                      </button>
                    </div>
                  </div>{" "}
                </div>
              </div>
              <div className="row" style={styles1}>
                <GCaudal1
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />

                <GVolumen1
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />
              </div>{" "}
              <div className="row" style={styles2}>
                <GCaudal2
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />

                <GVolumen2
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />
              </div>{" "}
              <div className="row">
                <GBatery
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />
                <GTempE
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />
                <GSignal
                  lecturas={this.state.lecturas}
                  contador={this.state.contador}
                />
              </div>
            </div>
          </section>

          <footer className="main-footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-6">
                  <p>Instrutrónica -Liderti &copy; 2019</p>
                </div>
                <div className="col-sm-6 text-right">
                  <p>Version 5.0.0</p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default withRouter(Graficas);
